import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setMeta } from '../utils/seo';

function NotFound() {
  useEffect(() => {
    setMeta({
      title: '404 - 页面不存在 | HHpoker官方网站',
      description: '你访问的页面不存在或已更换地址，可返回首页或前往下载、安装、客服等常用页面。',
      keywords: '404, 页面不存在, HHpoker官网, HHpoker下载, HHpoker客服',
      url: window.location.origin + window.location.pathname,
      image: window.location.origin + '/images/banner.jpg'
    });
  }, []);

  return (
    <div style={{ background: '#1a1c29', color: '#fff', minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 20px' }}>
      <div style={{ maxWidth: '680px', textAlign: 'center' }}>
        <h1 style={{ fontSize: '2.2rem', color: '#efa765', marginBottom: '10px' }}>404 页面不存在</h1>
        <p style={{ color: '#cfd3dc', marginBottom: '18px' }}>
          你访问的链接可能已失效。建议从首页重新进入，或使用下方常用入口快速跳转。
        </p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/" style={{ color: '#1a1c29', background: '#efa765', padding: '10px 16px', borderRadius: '20px', textDecoration: 'none', fontWeight: 700 }}>返回首页</Link>
          <Link to="/download" style={{ color: '#fff', border: '1px solid #efa765', padding: '10px 16px', borderRadius: '20px', textDecoration: 'none' }}>前往下载页</Link>
          <Link to="/contact" style={{ color: '#fff', border: '1px solid #efa765', padding: '10px 16px', borderRadius: '20px', textDecoration: 'none' }}>联系客服</Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
